var accordions = (function ($) {

    var _init = function () {
        var $accordions = $('.et_pb_toggle');

        if ($accordions.length > 0) {
            $accordions.find('.et_pb_toggle_title').on('click', _on_accordion_click);
        }
    };

    var _on_accordion_click = function (e) {
        var $this = $(this);
        var $accordion = $this.parent();
        var $content = $accordion.find('.et_pb_toggle_content');

        if ($accordion.hasClass('et_pb_toggle_open')) {
            $content.slideUp(700, function () {
                $accordion.removeClass('et_pb_toggle_open');
                $accordion.addClass('et_pb_toggle_close');
            });
        } else if ($accordion.hasClass('et_pb_toggle_close')) {
            $content.slideDown(700, function () {
                $accordion.removeClass('et_pb_toggle_close');
                $accordion.addClass('et_pb_toggle_open');
            });
        }
    };

    $(document).ready(_init);

    return {};

})(jQuery);

module.exports = accordions;